export enum DocumentTypeId {
  NONE = '0',
  CERTIDAO_DE_NASCIMENTO = '1',
  CERTIDAO_DE_CASAMENTO = '2',
  CERTIDAO_DE_OBITO = '3',
  IDENTIDADE_CIVIL = '4',
  IDENTIDADE_MILITAR = '5',
  IDENTIDADE_DE_CLASSE = '6',
  IDENTIDADE_FUNCIONAL = '7',
  IDENTIDADE_ESTRANGEIRA = '8',
  CNH = '9',
  CARTEIRA_DE_HABILITACAO_ESTRANGEIRA = '10',
  CARTEIRA_PROFISSIONAL = '12',
  PASSAPORTE = '13',
  TITULO_DE_ELEITOR = '14',
  PIS_PASEP = '15',
  CERTIFICADO_DE_RESERVISTA = '16',
  CPF = '11',
}
